import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { heroTitles: Array, heroSubtitles: Array };
  static targets = ["title", "subtitle", "video"];

  initialize() {
    let index = 0;
    this.setHeroContent(index);

    setInterval(() => {
      index += 1;
      if (index >= this.heroTitlesValue.length) {
        index = 0;
      }
      this.setHeroContent(index);
    }, 5000);
  }

  setHeroContent(index) {
    const title = this.heroTitlesValue[index];
    const subtitle = this.heroSubtitlesValue[index];
    this.titleTarget.innerText = title;
    this.subtitleTarget.innerText = subtitle;
    this.videoTargets.forEach((videoTarget) => {
      if (videoTarget.dataset.index == index) {
        videoTarget.classList.remove("invisible");
      } else {
        videoTarget.classList.add("invisible");
      }
    });
  }
}
